import { render, staticRenderFns } from "./CustomOperationsProducts.vue?vue&type=template&id=3bd08b76&scoped=true"
import script from "./CustomOperationsProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomOperationsProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomOperationsProducts.vue?vue&type=style&index=0&id=3bd08b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd08b76",
  null
  
)

export default component.exports